var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { CustomElement, P, PCSS, Defaults, Watch, PropertyConverters, ViewChild, Utils, CustomElementUtils, Components } from '@pacem/pacem-core';
import { Components as UIComponents } from '@pacem/pacem-ui';
const UI = UIComponents.UI;
//namespace Pacem.Components.Cms {
const DEFAULT_PERMISSION_METADATA = {
    props: [
        {
            prop: 'permissions',
            // child form-fields
            type: 'array',
            display: { name: 'Permissions' },
            props: {
                display: { cssClass: [PCSS + '-cell', PCSS + '-grid', 'grid-novgap', 'grid-tiny-colgap', 'grid-nospace'], name: 'Permission' },
                props: Array.prototype.concat.apply([
                    {
                        prop: 'claimType', type: 'string',
                        display: { cssClass: [PCSS + '-cell', 'cols-hd-4', 'cols-lg-6', 'field-stretch', 'field-minimal'], name: 'Claim type' },
                        validators: [{ type: 'required', errorMessage: '!' }]
                    },
                    {
                        prop: 'claimValue', type: 'string',
                        display: { cssClass: [PCSS + '-cell', 'cols-hd-4', 'cols-lg-6', 'field-stretch', 'field-minimal'], name: 'Claim value' },
                        validators: [{ type: 'required', errorMessage: '!' }]
                    },
                ], ['read', 'update', 'create', 'delete'].map((p, j) => {
                    return {
                        prop: p,
                        type: 'boolean',
                        display: { cssClass: [PCSS + '-cell', 'cols-hd-1', 'cols-3', 'field-minimal', PCSS + '-pad pad-left-2'], name: p.charAt(0).toUpperCase() + p.substr(1) }
                    };
                }))
            }
        }
    ]
};
export const DEFAULT_METADATA = {
    display: { name: 'Widget', cssClass: [PCSS + '-grid', 'grid-novgap', 'grid-tiny-colgap', 'grid-nospace'] },
    props: [
        { prop: 'tag', type: 'string', display: { name: 'Tag', cssClass: [PCSS + '-cell'] } }
    ]
};
function cellifyMetadata(p) {
    // ensure pacem-cell cssClass
    p.display = p.display || { name: p.prop, cssClass: [] };
    const css = p.display.cssClass = Utils.isArray(p.display.cssClass) && p.display.cssClass || [];
    css.push(PCSS + '-cell');
}
export function gridifyMetadata(metadata) {
    var props = metadata && metadata.props || [];
    var display = metadata && metadata.display || { name: 'Element' };
    if (!Utils.isNull(display)) {
        const css = display.cssClass = display.cssClass || [];
        Array.prototype.push.apply(css, DEFAULT_METADATA.display.cssClass);
    }
    props.forEach(cellifyMetadata);
    return { display: display, props: props };
}
export function buildWidgetMetadata(metadata) {
    var display = Utils.extend({}, DEFAULT_METADATA.display, metadata && metadata.display || {});
    var props = Utils.clone(DEFAULT_METADATA.props);
    Array.prototype.push.apply(props, (metadata && metadata.props || []).filter(p => {
        if (p.prop === 'tag') {
            return false;
        }
        cellifyMetadata(p);
        return true;
    }));
    return { display: display, props: props };
}
const WIDGET_CSS_CLASS = PCSS + '-widget';
/** Default metadata ('expression' field) 'extra' object. */
export const EXPRESSION_WIDGET_METADATA_EXTRA = {
    selector: '.' + WIDGET_CSS_CLASS,
    labeler: (e) => {
        if (!Utils.isNullOrEmpty(e.tag)) {
            return e.tag;
        }
        return (e.metadata && e.metadata.display && e.metadata.display.name || '') + '#' + e.id;
    }
};
export class Widget {
    /**
     * Utility method for widget gathering.
     * @param predicate Predicate for filtering
     */
    static findAll(predicate) {
        return CustomElementUtils.findAll('.' + WIDGET_CSS_CLASS, (widget) => widget instanceof PacemWidgetElement && !Utils.isNullOrEmpty(widget.id) && (Utils.isNull(predicate) || predicate(widget)));
    }
}
let PacemWidgetToolbarElement = class PacemWidgetToolbarElement extends Components.PacemElement {
    /** Gets the toolbar's edit button. */
    get editButton() {
        return this._btnEdit;
    }
    /** Gets the toolbar's permimssions button. */
    get permissionsButton() {
        return this._btnPerms;
    }
    /** Gets the toolbar's remove button. */
    get removeButton() {
        return this._btnRemove;
    }
    _edit(evt) {
        const form = this._proxy.dom.find(e => 'core' in e.attributes);
        form.open(this.target, true);
        form.metadata = this.target.metadata;
        // popout
        this._popoutJustInCase();
    }
    _editPermissions(evt) {
        const form = this._proxy.dom.find(e => 'permissions' in e.attributes);
        form.open(this.target);
        form.metadata = this.target.permissionMetadata;
        // popout
        this._popoutJustInCase();
    }
    _popoutJustInCase() {
        const balloon = CustomElementUtils.findAncestorOfType(this, UI.PacemBalloonElement);
        if (!Utils.isNullOrEmpty(balloon)) {
            balloon.popout();
        }
    }
};
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Element })
], PacemWidgetToolbarElement.prototype, "target", void 0);
__decorate([
    ViewChild('.buttons > div')
], PacemWidgetToolbarElement.prototype, "_toolbar", void 0);
__decorate([
    ViewChild(P + '-button[edit]')
], PacemWidgetToolbarElement.prototype, "_btnEdit", void 0);
__decorate([
    ViewChild(P + '-button[permissions]')
], PacemWidgetToolbarElement.prototype, "_btnPerms", void 0);
__decorate([
    ViewChild(P + '-button[remove]')
], PacemWidgetToolbarElement.prototype, "_btnRemove", void 0);
__decorate([
    ViewChild(P + '-shell-proxy')
], PacemWidgetToolbarElement.prototype, "_proxy", void 0);
PacemWidgetToolbarElement = __decorate([
    CustomElement({
        tagName: P + '-widget-toolbar', shadow: Defaults.USE_SHADOW_ROOT,
        template: `<${P}-span class="toolbar-text" content="{{ '<i class=&quot;${PCSS}-icon&quot;>'+ (::target.metadata && ::target.metadata.display && ::target.metadata.display.icon || 'widgets') +'</i> '+ (::target.tag || (::target.metadata && ::target.metadata.display && ::target.metadata.display.name || ::target.localName) +'#'+ ::target.id) }}"></${P}-span>
<div class="buttons ${PCSS}-buttonset ${PCSS}-pad ${PCSS}-margin pad-0 margin-left-2">
    <div class="buttonset-left">
        <${P}-button edit class="button edit" on-click=":host._edit($event)"></${P}-button>
        <${P}-button permissions class="button" on-click=":host._editPermissions($event)" css-class="{{ {'button-success': ::target.permissions.length > 0} }}" icon-glyph="verified_user"></${P}-button>
        <${P}-button remove class="button button-danger delete"></${P}-button>
    </div>
<div>
<${P}-shell-proxy>
    <${P}-modal-form core></${P}-modal-form>
    <${P}-modal-form permissions></${P}-modal-form>
</${P}-shell-proxy>`
    })
], PacemWidgetToolbarElement);
export { PacemWidgetToolbarElement };
export class PacemWidgetElement extends Components.PacemElement {
    constructor(metadata, role = 'widget') {
        super(role);
        this.permissionMetadata = DEFAULT_PERMISSION_METADATA;
        this.metadata = metadata;
    }
    connectedCallback() {
        super.connectedCallback();
        // ensure an explicit id for each widget
        if (Utils.isNullOrEmpty(this.id)) {
            this.id = 'wdg' + Utils.uniqueCode();
        }
        Utils.addClass(this, WIDGET_CSS_CLASS);
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        switch (name) {
            case 'editable':
                if (!val) {
                    this._disposeBalloon();
                }
                else if (this.isReady) {
                    this._ensureBalloon();
                }
                break;
            case 'editing':
                if (!Utils.isNull(this._balloon)) {
                    this._balloon.disabled = !val;
                }
                (val ? Utils.addClass : Utils.removeClass).apply(this, [this, 'widget-' + name]);
                break;
            case 'metadata':
                this._assignIcon(val);
                break;
        }
    }
    viewActivatedCallback() {
        super.viewActivatedCallback();
        this._assignIcon();
        this._ensureBalloon();
    }
    disconnectedCallback() {
        super.disconnectedCallback();
    }
    _assignIcon(val = this.metadata) {
        this.dataset['icon'] = (val && val.display && val.display.icon) || 'widgets';
    }
    _ensureBalloon() {
        if (Utils.isNull(this._balloon)) {
            const balloon = this._balloon = document.createElement(P + '-balloon');
            balloon.target = this;
            balloon.disabled = !this.editing;
            balloon.options = {
                behavior: UI.BalloonBehavior.Menu,
                trigger: UI.BalloonTrigger.Hover
            };
            // innerHTML before appending the balloon to the DOM.
            balloon.innerHTML = `<${P}-widget-toolbar target="{{ #${this.id} }}"><${P}-widget-toolbar>`;
            // append to trigger connected/viewActivated callbacks
            CustomElementUtils.findAncestorShell(this).appendChild(balloon);
        }
    }
    _disposeBalloon() {
        if (!Utils.isNull(this._balloon)) {
            this._balloon.remove();
            this._balloon = null;
        }
    }
}
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Boolean })
], PacemWidgetElement.prototype, "editing", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Boolean })
], PacemWidgetElement.prototype, "editable", void 0);
__decorate([
    Watch({ emit: true, reflectBack: true, converter: PropertyConverters.String })
], PacemWidgetElement.prototype, "tag", void 0);
__decorate([
    Watch({ emit: false, reflectBack: true, converter: PropertyConverters.Json })
], PacemWidgetElement.prototype, "permissions", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Json })
], PacemWidgetElement.prototype, "metadata", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Json })
], PacemWidgetElement.prototype, "permissionMetadata", void 0);
